import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Grid, GridNoRecords, GridColumn, getSelectedState, getSelectedStateFromKeyDown } from '@progress/kendo-react-grid';
import { getter } from "@progress/kendo-react-common";

import LoadingPanel from 'views/widgets/LoadingPanel.jsx';
import { addMessage } from '../../../messages/messageSlice'

export default function QueryCustomIndexDialog(props) {

	let { field, okCallback, cancelCallback, workflowId, fromAdmin = false } = props;
	
	const [state, setState] = useState({masked: false, valuesFetched: false, options: []})
	const dispatch = useDispatch();
	const focusRef = useRef();
	
	const DATA_ITEM_KEY = "valueStr";
	const SELECTED_FIELD = "selected";
	const idGetter = getter(DATA_ITEM_KEY);
	const [selectedState, setSelectedState] = useState({});
	
	useEffect(() => {
		focusRef.current.focus();
	}, []);

  	const onSelectionChange = (event) => {
    	const newSelectedState = getSelectedState({
      		event,
      		selectedState: selectedState,
      		dataItemKey: DATA_ITEM_KEY,
    	});
    	setSelectedState(newSelectedState);
  	};
  	
	const onKeyDown = (event) => {
    	const newSelectedState = getSelectedStateFromKeyDown({
      		event,
      		selectedState: selectedState,
      		dataItemKey: DATA_ITEM_KEY,
    	});
    	setSelectedState(newSelectedState);
  	};

	const getSelected = () => {
		for (let i = 0; i < state.options.length; i++) 
			if (selectedState[state.options[i].valueStr])
				return state.options[i].valueStr;
		return undefined;
	};
	
	const runScript = () => {
		let options = {
			credentials: 'include',
			method: 'GET',
			headers: { 'Content-Type': 'application/json' }
		}
		setState({...state, masked: true});
		fetch(API_URL + '/api/queries/getFieldValues/' + field.id  + '?' + (workflowId ? '&workflowId=' + workflowId : '') + '&fromAdmin=' + fromAdmin, options
		).then((response) => {
			if (response.ok) { return response.json(); }
			else { throw new Error(response.status); }
		}).then((json) => {
			if (json.errors && json.errors["0"] && json.errors["0"].length > 0) throw new Error(json.errors["0"][0]);
			setState({masked: false, valuesFetched: true, options: getOptionsFromJson(json)});
		}).catch((err) => {
			let errMsg = (err.message === '403') ? ("Unauthorized session!")
			           : (err.message === '500') ? ("Failed to fetch options.  If this problem persists, please contact Support.")
			           : err.message;  
			setState({masked: false, valuesFetched: true, options: []});
			dispatch(addMessage({ type: 'error', msg: errMsg }));
		});
	};
	
	const getOptionsFromJson = (json) => {
		let options = [];
		let retval = json.returnValue;
		let result = JSON.parse((retval ? retval.value : undefined));
		for (let i = 0; i < result.length; i++) options.push({ valueStr: result[i] });
		return options;
	};

	if (!state.valuesFetched && !state.masked) runScript(); 
	return (
		<Dialog title={field.name} onClose={cancelCallback}>
	    	<div>
	    		{ state.masked && ( <LoadingPanel /> ) } 
	    		<Grid
					style={{
						width: "500px",
						height: "300px"
					}}

					data={state.options.map((option) => ({
						...option,
						[SELECTED_FIELD]: selectedState[idGetter(option)],
					}))}
					dataItemKey={DATA_ITEM_KEY}
					selectedField={SELECTED_FIELD}
					selectable={{
						enabled: true,
						drag: false,
						cell: false,
						mode: "single"
					}}
        			navigatable={true}
        			onSelectionChange={onSelectionChange}
        			onKeyDown={onKeyDown}
				>
				 	<GridNoRecords>
				 		<div></div>
				 	</GridNoRecords>
					<GridColumn key="valueStr" field="valueStr" title={field.name} width="400px" />
				</Grid>
			</div>
			<DialogActionsBar>
	        	<button
	            	className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
	            	onClick={() => { okCallback(getSelected()); }}
	            >
	            	Ok
	            </button>
            	<button
            		ref={focusRef}
            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
            		onClick={cancelCallback}
            	>
            		Cancel
            	</button>
			</DialogActionsBar>            	
		</Dialog>
	);
}